import { useQuery } from '@tanstack/react-query';
import { getFamiliesWithStats, getAllUsers } from '../services/adminService';
import { Building2, Users, UserCheck, UserX } from 'lucide-react';
import './DashboardScreen.css';

export default function DashboardScreen() {
  const { data: families, isLoading: familiesLoading } = useQuery({
    queryKey: ['families'],
    queryFn: getFamiliesWithStats,
  });

  const { data: users, isLoading: usersLoading } = useQuery({
    queryKey: ['users'],
    queryFn: getAllUsers,
  });

  if (familiesLoading || usersLoading) {
    return (
      <div className="dashboard-loading">
        <p>Loading dashboard...</p>
      </div>
    );
  }

  const totalFamilies = families?.length || 0;
  const totalUsers = users?.length || 0;
  const totalCaregivers = users?.filter(u => u.role === 'user').length || 0;
  const totalMembers = users?.filter(u => u.role === 'familyMember').length || 0;
  const activeFamilies = families?.filter(f => f.isActive).length || 0;

  const stats = [
    {
      label: 'Total Families',
      value: totalFamilies,
      icon: Building2,
      color: '#2AB7A9',
      subtitle: `${activeFamilies} active`,
    },
    {
      label: 'Total Users',
      value: totalUsers,
      icon: Users,
      color: '#3B82F6',
      subtitle: 'All roles',
    },
    {
      label: 'Caregivers',
      value: totalCaregivers,
      icon: UserCheck,
      color: '#10B981',
      subtitle: 'Active caregivers',
    },
    {
      label: 'Family Members',
      value: totalMembers,
      icon: UserX,
      color: '#F59E0B',
      subtitle: 'Being monitored',
    },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>Overview of your Quatro Care system</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.label} className="stat-card">
              <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                <Icon size={24} />
              </div>
              <div className="stat-content">
                <p className="stat-value">{stat.value}</p>
                <p className="stat-label">{stat.label}</p>
                <p className="stat-subtitle">{stat.subtitle}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="dashboard-section">
        <h2>Recent Families</h2>
        {families && families.length > 0 ? (
          <div className="families-list">
            {families.slice(0, 5).map((family) => (
              <div key={family.id} className="family-card">
                <div className="family-info">
                  <h3>{family.name}</h3>
                  <p className="family-meta">
                    {family.userCount} users • {family.caregiverCount} caregivers • {family.memberCount} members
                  </p>
                  {family.subscriptionTier && (
                    <span className={`subscription-badge ${family.subscriptionTier}`}>
                      {family.subscriptionTier}
                    </span>
                  )}
                </div>
                <div className="family-status">
                  <span className={`status-dot ${family.isActive ? 'active' : 'inactive'}`} />
                  <span>{family.isActive ? 'Active' : 'Inactive'}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="empty-state">No families yet. Create your first family to get started.</p>
        )}
      </div>
    </div>
  );
}

